export default __webpack_public_path__ + "media/images/icons/calendar-checked-ebff8a2fddc27d8c9fa8a652dfeaa779.svg";